<script>
import * as echarts from "echarts";
import {getAllArea} from "@/api/device-manager-api";
import {getHomeTotal} from "@/api/record-api";
import {getAllDepartment} from "@/api/organize-api";

// 品牌图表色板
const COLORS = {
  blue: "#2563eb",
  indigo: "#4f46e5",
  green: "#10b981",
  amber: "#f59e0b",
  orange: "#f97316",
  purple: "#8b5cf6",
  gray: "#9ca3af",
};

export default {
  name: "HomePage",
  data() {
    return {
      form: {
        timeType: "today",
        selectAreaName: "全部",
        areaSelectNote: {name: "全部", areas: [], id: -1, parentId: -1},
        departmentName: [],
        departmentChoice: []
      },

      timeSelectorOptions: [
        {label: "当日", value: "today"},
        {label: "本周", value: "thisWeek"},
        {label: "双周", value: "twoWeek"},
        {label: "本月", value: "thisMonth"},
        {label: "本年", value: "thisYear"},
        {label: "上年", value: "lastYear"},
      ],

      allAreaTree: [{name: "全部", areas: [], id: -1, parentId: -1}],
      siteMap: {},
      areaProps: {children: "areas", label: "name"},

      homeTotalData: null,

      departmentTree: [{name: "全部", departments: [], id: -1}],
      defaultProps: {children: "departments", label: "name"},

      charts: [],
      watchDelayTimer: null,
    };
  },

  computed: {
    // 周期文案
    periodText() {
      const map = {
        today: "今日",
        thisWeek: "本周",
        twoWeek: "双周",
        thisMonth: "本月",
        thisYear: "本年",
        lastYear: "上年",
      };
      return map[this.form.timeType] || "今日";
    },

    // KPI 指标
    kpiExpected() {
      if (!this.homeTotalData) return 0;
      return (this.homeTotalData.bookNum || 0) + (this.homeTotalData.inviteNum || 0);
    },
    kpiCheckIn() {
      return this.homeTotalData ? (this.homeTotalData.checkInNum || 0) : 0;
    },
    kpiCheckOut() {
      return this.homeTotalData ? (this.homeTotalData.checkOutNum || 0) : 0;
    },
    kpiOnline() {
      return this.homeTotalData ? (this.homeTotalData.onlineNum || 0) : 0;
    },
    kpiPending() {
      return Math.max(this.kpiExpected - this.kpiCheckIn, 0);
    },
    arrivalRate() {
      if (this.kpiExpected === 0) return "0%";
      return Math.round((this.kpiCheckIn / this.kpiExpected) * 100) + "%";
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.$refs.departmentTree.setCheckedKeys([-1])
    })
    getAllDepartment().then(({data}) => {
      this.departmentTree.push(...data.data)
    }).catch(err => {
      console.error("getAllDepartment err", err);
    })

    getAllArea().then(({data}) => {
      if (data.code === 200) {
        this.allAreaTree.push(...data.data)
        data.data.forEach(item => {
          this.siteMap[item.id] = item
          ;(item.areas || []).forEach(area => {
            this.siteMap[area.id] = area
          })
        })
      } else {
        this.$message.error("获取区域信息失败")
      }
      this.onSelectChange()
    }).catch((error) => {
      this.$message.error("获取区域信息失败")
      console.log(error);
    });

    window.addEventListener("resize", this.onResize);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
    this.charts.forEach(c => c.dispose());
    this.charts = [];
  },

  methods: {

    onResize() {
      this.charts.forEach(c => c.resize());
    },

    areaName(key) {
      const keyNum = parseInt(key);
      if (keyNum === -1) return "其他";
      const item = this.siteMap[keyNum];
      return item ? item.name : "未知区域";
    },

    areaNodeEnterClick(e) {
      this.form.selectAreaName = e.name;
      this.form.areaSelectNote = e;
    },

    onSelectChange() {
      let type = null
      let year = null
      let areaIds = null
      let departIds = null
      let date = new Date()
      switch (this.form.timeType) {
        case "today":
          type = "TODAY"
          break;
        case "thisWeek":
          type = "WEEK"
          break;
        case "twoWeek":
          type = "WEEK_TWO"
          break;
        case "thisMonth":
          type = "MONTH"
          break;
        case "thisYear":
          type = "YEAR"
          year = date.getFullYear()
          break;
        case "lastYear":
          type = "YEAR"
          year = date.getFullYear() - 1
          break;
      }
      if (this.form.selectAreaName && this.form.selectAreaName !== "全部") {
        let area = this.siteMap[this.form.areaSelectNote.id]
        if (area.parentId === -1) {
          areaIds = (area.areas || []).map(item => item.id)
          if (areaIds.length === 0) {
            areaIds = [area.id]
          }
        } else {
          areaIds = [area.id]
        }
      }

      if (this.form.departmentName && this.form.departmentName !== "全部") {
        let ids = this.$refs.departmentTree.getCheckedKeys().filter(item => item !== -1)
        if (ids.length > 0) {
          departIds = ids
        }
      }

      getHomeTotal(type, year, areaIds, departIds).then(({data}) => {
        if (data.code === 200) {
          this.homeTotalData = data.data
          this.$nextTick(() => {
            this.renderTrendChart()
            this.renderSourceChart()
            this.renderAreaChart()
            this.renderOnlineChart()
          })
        }
      }).catch((error) => {
        console.log(error);
      });
    },

    // 图表通用配置
    baseOption() {
      return {
        color: [COLORS.blue, COLORS.green, COLORS.amber, COLORS.purple, COLORS.orange],
        textStyle: {fontFamily: "inherit"},
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(17, 24, 39, 0.88)",
          borderWidth: 0,
          textStyle: {color: "#fff", fontSize: 12},
          axisPointer: {type: "shadow", shadowStyle: {color: "rgba(37, 99, 235, 0.06)"}},
        },
        grid: {top: 42, left: 12, right: 16, bottom: 8, containLabel: true},
      };
    },

    makeChart(ref) {
      const el = this.$refs[ref];
      if (!el) return null;
      const exist = this.charts.find(c => c.getDom() === el);
      if (exist) return exist;
      const chart = echarts.init(el);
      this.charts.push(chart);
      return chart;
    },

    // 图1：签到/签退趋势（按时段）
    renderTrendChart() {
      const chart = this.makeChart("trendChart");
      if (!chart || !this.homeTotalData) return;

      const durations = this.homeTotalData.durations || [];
      const xData = [];
      const inData = [];
      const outData = [];
      const length = durations.length;

      for (let i = 0; i < length; i++) {
        inData.push(durations[i].checkInNum);
        outData.push(durations[i].checkOutNum);
      }
      switch (this.form.timeType) {
        case "today":
          for (let i = 0; i < length; i++) xData.push(`${i * 2}时`);
          break;
        case "thisWeek":
          for (let i = 0; i < length; i++) xData.push(`周${i + 1}`);
          break;
        case "twoWeek":
          for (let i = 0; i < length; i++) xData.push(`第${i + 1}天`);
          break;
        case "thisMonth":
          for (let i = 0; i < length; i++) xData.push(`${i + 1}日`);
          break;
        default:
          for (let i = 0; i < length; i++) xData.push(`${i + 1}月`);
      }

      chart.setOption({
        ...this.baseOption(),
        legend: {data: ["签到", "签离"], top: 6, right: 8, icon: "roundRect", itemWidth: 14, itemHeight: 8},
        xAxis: {
          type: "category",
          data: xData,
          axisLine: {lineStyle: {color: "#e5e9f0"}},
          axisTick: {show: false},
          axisLabel: {color: "#9ca3af", fontSize: 11},
        },
        yAxis: {
          type: "value",
          splitLine: {lineStyle: {color: "#f0f2f7", type: "dashed"}},
          axisLabel: {color: "#9ca3af", fontSize: 11},
        },
        series: [
          {
            name: "签到",
            type: "bar",
            data: inData,
            barWidth: 12,
            itemStyle: {
              borderRadius: [6, 6, 0, 0],
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {offset: 0, color: "#60a5fa"},
                {offset: 1, color: "#2563eb"},
              ]),
            },
          },
          {
            name: "签离",
            type: "bar",
            data: outData,
            barWidth: 12,
            itemStyle: {
              borderRadius: [6, 6, 0, 0],
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {offset: 0, color: "#6ee7b7"},
                {offset: 1, color: "#10b981"},
              ]),
            },
          },
        ],
      }, true);
    },

    // 图2：来访方式构成（预约/邀约）
    renderSourceChart() {
      const chart = this.makeChart("sourceChart");
      if (!chart || !this.homeTotalData) return;

      const book = this.homeTotalData.bookNum || 0;
      const invite = this.homeTotalData.inviteNum || 0;
      const data = [];
      if (book > 0) data.push({name: "访客预约", value: book});
      if (invite > 0) data.push({name: "员工邀约", value: invite});
      if (data.length === 0) data.push({name: "暂无数据", value: 1, empty: true});

      chart.setOption({
        color: data[0] && data[0].empty ? ["#e5e9f0"] : [COLORS.blue, COLORS.purple],
        tooltip: {
          trigger: "item",
          backgroundColor: "rgba(17, 24, 39, 0.88)",
          borderWidth: 0,
          textStyle: {color: "#fff", fontSize: 12},
          formatter: (p) => (p.data.empty ? "暂无数据" : `${p.name}：${p.value} 人（${p.percent}%）`),
        },
        legend: {bottom: 4, icon: "circle", itemWidth: 8, itemHeight: 8, textStyle: {color: "#6b7280", fontSize: 12}},
        series: [
          {
            type: "pie",
            radius: ["52%", "72%"],
            center: ["50%", "44%"],
            avoidLabelOverlap: true,
            itemStyle: {borderRadius: 6, borderColor: "#fff", borderWidth: 2},
            label: {show: false},
            emphasis: {label: {show: true, fontSize: 14, fontWeight: 600}},
            data,
          },
        ],
      }, true);
    },

    // 图3：区域到访分布（签到/签离/在园）
    renderAreaChart() {
      const chart = this.makeChart("areaChart");
      if (!chart || !this.homeTotalData) return;

      const keys = {};
      ["areaCheckInNum", "areaCheckOutNum", "areaOnlineNum"].forEach(field => {
        Object.keys(this.homeTotalData[field] || {}).forEach(k => {
          keys[k] = true;
        });
      });

      const names = [];
      const checkIns = [];
      const checkOuts = [];
      const onlines = [];
      Object.keys(keys).forEach(k => {
        names.push(this.areaName(k));
        checkIns.push((this.homeTotalData.areaCheckInNum || {})[k] || 0);
        checkOuts.push((this.homeTotalData.areaCheckOutNum || {})[k] || 0);
        onlines.push((this.homeTotalData.areaOnlineNum || {})[k] || 0);
      });

      chart.setOption({
        ...this.baseOption(),
        legend: {data: ["签到", "签离", "在园"], top: 6, right: 8, icon: "roundRect", itemWidth: 14, itemHeight: 8},
        xAxis: {
          type: "category",
          data: names.length ? names : ["暂无数据"],
          axisLine: {lineStyle: {color: "#e5e9f0"}},
          axisTick: {show: false},
          axisLabel: {color: "#9ca3af", fontSize: 11, interval: 0},
        },
        yAxis: {
          type: "value",
          splitLine: {lineStyle: {color: "#f0f2f7", type: "dashed"}},
          axisLabel: {color: "#9ca3af", fontSize: 11},
        },
        series: [
          {name: "签到", type: "bar", data: checkIns, barWidth: 10, itemStyle: {borderRadius: [5, 5, 0, 0], color: COLORS.blue}},
          {name: "签离", type: "bar", data: checkOuts, barWidth: 10, itemStyle: {borderRadius: [5, 5, 0, 0], color: COLORS.green}},
          {name: "在园", type: "bar", data: onlines, barWidth: 10, itemStyle: {borderRadius: [5, 5, 0, 0], color: COLORS.amber}},
        ],
      }, true);
    },

    // 图4：在园区域排行（横向条形）
    renderOnlineChart() {
      const chart = this.makeChart("onlineChart");
      if (!chart || !this.homeTotalData) return;

      const onlineMap = this.homeTotalData.areaOnlineNum || {};
      const items = Object.keys(onlineMap)
          .map(k => ({name: this.areaName(k), value: onlineMap[k] || 0}))
          .filter(it => it.value > 0)
          .sort((a, b) => a.value - b.value);

      chart.setOption({
        ...this.baseOption(),
        grid: {top: 16, left: 12, right: 32, bottom: 8, containLabel: true},
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(17, 24, 39, 0.88)",
          borderWidth: 0,
          textStyle: {color: "#fff", fontSize: 12},
          axisPointer: {type: "shadow"},
        },
        xAxis: {
          type: "value",
          splitLine: {lineStyle: {color: "#f0f2f7", type: "dashed"}},
          axisLabel: {color: "#9ca3af", fontSize: 11},
        },
        yAxis: {
          type: "category",
          data: items.length ? items.map(it => it.name) : ["暂无在园访客"],
          axisLine: {show: false},
          axisTick: {show: false},
          axisLabel: {color: "#4b5563", fontSize: 12},
        },
        series: [
          {
            type: "bar",
            data: items.length ? items.map(it => it.value) : [0],
            barWidth: 12,
            label: {show: true, position: "right", color: "#6b7280", fontSize: 11},
            itemStyle: {
              borderRadius: [0, 6, 6, 0],
              color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                {offset: 0, color: "#818cf8"},
                {offset: 1, color: "#4f46e5"},
              ]),
            },
          },
        ],
      }, true);
    },

    onRemoveTag(tag) {
      let findDepartment = this.form.departmentChoice.find(item => item.name === tag)
      if (findDepartment) {
        let selectIds = this.$refs.departmentTree.getCheckedKeys()
        let newSelectIds = selectIds.filter(item => item !== findDepartment.id)
        this.$refs.departmentTree.setCheckedKeys(newSelectIds)
      }
    },

    handleCheckChange(data, checked, indeterminate) {
      if (checked) {
        this.form.departmentName.push(data.name)
        this.form.departmentChoice.push(data)
      } else {
        let findIndex = this.form.departmentName.findIndex(item => item === data.name)
        if (findIndex !== -1) {
          this.form.departmentName.splice(findIndex, 1)
        }
        this.form.departmentChoice = this.form.departmentChoice.filter(item => item.id !== data.id)
      }
    },

  },

  watch: {
    form: {
      handler: function () {
        if (this.watchDelayTimer) {
          clearTimeout(this.watchDelayTimer)
        }
        this.watchDelayTimer = setTimeout(() => {
          this.onSelectChange()
        }, 100)
      },
      deep: true
    }
  }

}
</script>

<template>
  <div class="dash-page">
    <!-- 筛选栏 -->
    <div class="filter-card">
      <el-form :model="form" label-width="80px" inline>
        <el-form-item label="时间类型">
          <el-select v-model="form.timeType" placeholder="请选择">
            <el-option
                v-for="item in timeSelectorOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部门">
          <el-select v-model="form.departmentName" :placeholder="`请选择部门`" multiple collapse-tags
                     :popper-append-to-body="false" value-key="name" @remove-tag="onRemoveTag">
            <el-option :value="form.departmentChoice" class="setstyle" style="overflow: auto; height: 100%" disabled
                       :key="form.departmentChoice.id" :label="form.departmentChoice.name">
              <el-tree style="min-height: 150px; max-height: 300px" :data="departmentTree" :props="defaultProps"
                       ref="departmentTree" show-checkbox @check-change="handleCheckChange" node-key="id"
                       default-expand-all :expand-on-click-node="false"></el-tree>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="区域">
          <el-select v-model="form.selectAreaName" :placeholder="`请选择签到区域`"
                     :popper-append-to-body="false" value-key="id">
            <el-option :value="form.areaSelectNote" class="setstyle" style="overflow: auto; height: 100%"
                       disabled
                       :key="form.areaSelectNote.id" :label="form.areaSelectNote.name">
              <el-tree style="min-height: 150px; max-height: 300px" :data="allAreaTree" :props="areaProps"
                       ref="tree"
                       check-strictly :expand-on-click-node="false"
                       @node-click="(data, node, item) => areaNodeEnterClick(data, node, item)"></el-tree>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>

    <!-- KPI 指标行 -->
    <div class="kpi-row">
      <div class="kpi-card">
        <div class="kpi-icon icon-blue"><i class="el-icon-date"></i></div>
        <div class="kpi-body">
          <div class="kpi-value">{{ kpiExpected }}</div>
          <div class="kpi-label">{{ periodText }}预计到访</div>
          <div class="kpi-sub">预约 {{ homeTotalData ? homeTotalData.bookNum : 0 }} ·
            邀约 {{ homeTotalData ? homeTotalData.inviteNum : 0 }}
          </div>
        </div>
      </div>

      <div class="kpi-card">
        <div class="kpi-icon icon-green"><i class="el-icon-circle-check"></i></div>
        <div class="kpi-body">
          <div class="kpi-value">{{ kpiCheckIn }}</div>
          <div class="kpi-label">{{ periodText }}已签到</div>
          <div class="kpi-sub">到访率 {{ arrivalRate }}</div>
        </div>
      </div>

      <div class="kpi-card">
        <div class="kpi-icon icon-amber"><i class="el-icon-remove"></i></div>
        <div class="kpi-body">
          <div class="kpi-value">{{ kpiCheckOut }}</div>
          <div class="kpi-label">{{ periodText }}已签离</div>
          <div class="kpi-sub">完成离场登记</div>
        </div>
      </div>

      <div class="kpi-card kpi-accent">
        <div class="kpi-icon icon-white"><i class="el-icon-position"></i></div>
        <div class="kpi-body">
          <div class="kpi-value">{{ kpiOnline }}</div>
          <div class="kpi-label">当前在园（实时）</div>
          <div class="kpi-sub">正在园区内的访客</div>
        </div>
      </div>

      <div class="kpi-card">
        <div class="kpi-icon icon-purple"><i class="el-icon-alarm-clock"></i></div>
        <div class="kpi-body">
          <div class="kpi-value">{{ kpiPending }}</div>
          <div class="kpi-label">{{ periodText }}待到访</div>
          <div class="kpi-sub">已登记未签到</div>
        </div>
      </div>
    </div>

    <!-- 图表行 1：趋势 + 来源构成 -->
    <div class="chart-row">
      <div class="chart-card chart-wide">
        <div class="chart-head">
          <span class="chart-title">{{ periodText }}签到 / 签退趋势</span>
          <span class="chart-hint">用于安排前台与门岗人力</span>
        </div>
        <div class="chart-box" ref="trendChart"></div>
      </div>

      <div class="chart-card chart-narrow">
        <div class="chart-head">
          <span class="chart-title">来访方式构成</span>
          <span class="chart-hint">预约 vs 邀约</span>
        </div>
        <div class="chart-box" ref="sourceChart"></div>
      </div>
    </div>

    <!-- 图表行 2：区域分布 + 在园排行 -->
    <div class="chart-row">
      <div class="chart-card chart-wide">
        <div class="chart-head">
          <span class="chart-title">区域到访分布</span>
          <span class="chart-hint">各区域签到 / 签离 / 在园对比</span>
        </div>
        <div class="chart-box" ref="areaChart"></div>
      </div>

      <div class="chart-card chart-narrow">
        <div class="chart-head">
          <span class="chart-title">在园区域排行</span>
          <span class="chart-hint">实时</span>
        </div>
        <div class="chart-box" ref="onlineChart"></div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="less">
.dash-page {
  min-height: calc(100vh - 64px);
  padding: 20px 24px;
  background: #f5f7fb;
}

/* ---------- 筛选栏 ---------- */
.filter-card {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #edf0f5;
  box-shadow: 0 1px 3px rgba(17, 24, 39, 0.04);
  padding: 18px 20px 2px;
  margin-bottom: 16px;
}

/* ---------- KPI ---------- */
.kpi-row {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
  margin-bottom: 16px;
}

.kpi-card {
  display: flex;
  align-items: center;
  gap: 14px;
  background: #fff;
  border-radius: 12px;
  border: 1px solid #edf0f5;
  box-shadow: 0 1px 3px rgba(17, 24, 39, 0.04);
  padding: 18px 20px;
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(17, 24, 39, 0.08);
  }
}

.kpi-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  border-radius: 12px;
  font-size: 22px;
  flex-shrink: 0;
}

.icon-blue {
  background: rgba(37, 99, 235, 0.1);
  color: #2563eb;
}

.icon-green {
  background: rgba(16, 185, 129, 0.12);
  color: #059669;
}

.icon-amber {
  background: rgba(245, 158, 11, 0.14);
  color: #d97706;
}

.icon-purple {
  background: rgba(139, 92, 246, 0.12);
  color: #7c3aed;
}

.icon-white {
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
}

.kpi-value {
  font-size: 28px;
  font-weight: 700;
  line-height: 1.1;
  color: #111827;
  font-variant-numeric: tabular-nums;
}

.kpi-label {
  margin-top: 4px;
  font-size: 13px;
  color: #4b5563;
}

.kpi-sub {
  margin-top: 2px;
  font-size: 11px;
  color: #9ca3af;
}

/* 强调卡片：当前在园 */
.kpi-accent {
  background: linear-gradient(120deg, #1d4ed8 0%, #4f46e5 100%);
  border: none;
  box-shadow: 0 8px 24px rgba(37, 99, 235, 0.35);

  .kpi-value {
    color: #fff;
  }

  .kpi-label {
    color: rgba(255, 255, 255, 0.85);
  }

  .kpi-sub {
    color: rgba(255, 255, 255, 0.6);
  }

  &:hover {
    box-shadow: 0 12px 28px rgba(37, 99, 235, 0.45);
  }
}

/* ---------- 图表卡片 ---------- */
.chart-row {
  display: grid;
  grid-template-columns: 3fr 2fr;
  gap: 16px;
  margin-bottom: 16px;
}

.chart-card {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #edf0f5;
  box-shadow: 0 1px 3px rgba(17, 24, 39, 0.04);
  padding: 18px 20px;
}

.chart-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 8px;
}

.chart-title {
  font-size: 15px;
  font-weight: 600;
  color: #111827;
  position: relative;
  padding-left: 10px;

  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 2px;
    bottom: 2px;
    width: 3px;
    border-radius: 2px;
    background: linear-gradient(180deg, #2563eb, #4f46e5);
  }
}

.chart-hint {
  font-size: 12px;
  color: #9ca3af;
}

.chart-box {
  width: 100%;
  height: 300px;
}

/* ---------- 响应式 ---------- */
@media (max-width: 1280px) {
  .kpi-row {
    grid-template-columns: repeat(3, 1fr);
  }

  .chart-row {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .kpi-row {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
